export default __webpack_public_path__ + "images/rosabandet/ica/icon-pin.png";